import React from 'react';
import DesignRushLogo from "../assets/Logo/Top WEB DESIGN Agencies.png"
import CluckLogo from "../assets/Logo/clutch-image.png"

function Brandlist() {
  return (
    <div className="pb-16 bg-[#CFF098]">
      <div className="container mx-auto pt-16 bg-[#CFF098]">
        <div className="w-11/12 xl:w-2/3 mx-auto mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4 uppercase">
            As Seen On
          </h2>
          <p className="text-base md:text-lg text-black">
            Woaom Web Design has been proudly featured across leading online platforms and creative networks. Our work continues to inspire and support visionary brands ready to scale with custom, code-based solutions.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-y-12 gap-x-8 px-4">
        <a href='https://www.designrush.com/agency/website-design-development/texas/austin'>
          <img src={DesignRushLogo} alt="Woaom Web Design's rating on DesignRush, the industry-leading B2B Marketplace connecting brands with agencies." className="h-40 object-contain"  />
          </a>
           <a href='https://clutch.co/web-designers/austin'>
          <img src={CluckLogo} alt="Chanel" className="h-20 object-contain mt-10" />
         </a>
        </div>
      </div>
    </div>
  );
}

export default Brandlist;
